/* global translationsFilter */
/* global woof_current_values */

export default {
  init() {
    addBackButtonFunctionality();
    addClassToSinglePrice();
    initProductArchiveColorHover();
    initWoofFilterAccordions();
    initMobileFilterToggle();
    initCustomSortingWidget();
    initVideoClickArchive();
    styleTopPanelColors();
    styleSidebarColors();
    backToTop();
    initChosenFiltersText();

    $(document).on('mousedown', '.woof_products_top_panel li a, .woof_products_top_panel_ul li a', function() {
      const tax = $(this).data('tax');
      if (tax && typeof woof_current_values !== 'undefined') {
        if (typeof woof_current_values[tax] === 'undefined') {
          woof_current_values[tax] = '';
        }
      }
    });

    $(document).on('click', '.woof_list li', function(e) {
      if ($(this).closest('.woof_list_color').length) {
        return;
      }

      if ($(e.target).is('input, .woof_color_checked, .checkbox.woof_color_term, label')) {
        return;
      }
      e.preventDefault();
      const $checkbox = $(this).find('input[type="checkbox"]');
      if ($checkbox.length) {
        $checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
      }
    });

    $('.orderby').each(function() {
      $(this).select2({
        minimumResultsForSearch: Infinity,
        width: '100%',
      });
    });

    let resizeTimer;
    $(window).on('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        checkActiveFilters();
      }, 250);
    });

    $(document).on('woof_ajax_done', function() {
      checkActiveFilters();
      styleTopPanelColors();
      styleSidebarColors();
      initChosenFiltersText();
      updateDesktopProductCount();
      updateMobileFilterButtonState();
    });

    updateMobileFilterButtonState();
  },
  finalize() {

  },
};

export var updateMobileFilterButtonState = () => {
  const $btn = $('.btn-inline-filter');
  if (!$btn.length) return;

  let activeCount = 0;

  $('.wolky-productcategories-content').first().find('.woof_container_inner').each(function() {
    activeCount += $(this).find('input:checked').length;
    $(this).find('select option:selected:not([value="0"]):not([value=""])').each(function() {
      activeCount++;
    });
  });

  let svgIcon = $btn.find('svg').prop('outerHTML') || '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="16" height="16"><polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon></svg>';
  let FilterText = window.translationsFilter['mobileFilterTextFilter'];

  if (activeCount > 0) {
    $btn.addClass('has-active-filters');
    $btn.html(svgIcon + ' ' + FilterText + ' ' + '(' + activeCount + ')');
  } else {
    $btn.removeClass('has-active-filters');
    $btn.html(svgIcon + ' ' + FilterText);
  }
};

export var initCustomSortingWidget = () => {
  const checkboxes = document.querySelectorAll('.ws-sort-checkbox');
  if (checkboxes.length === 0) return;

  const urlParams = new URLSearchParams(window.location.search);
  const currentOrder = urlParams.get('orderby');

  if (currentOrder) {
    const activeBox = document.querySelector(`.ws-sort-checkbox[value="${currentOrder}"]`);
    if (activeBox) activeBox.checked = true;
  }

  checkboxes.forEach(box => {
    box.addEventListener('change', function() {
      if (this.checked) {
        checkboxes.forEach(b => { if (b !== this) b.checked = false; });
        urlParams.set('orderby', this.value);
      } else {
        urlParams.delete('orderby');
      }
      window.location.search = urlParams.toString();
    });
  });
}

export var updateDesktopProductCount = () => {
  const $resultsWrapper = $('#woof_results_by_ajax');
  let actueleCount = $resultsWrapper.attr('data-count');

  const $countSpan = $('.category-product-count, .shop-total-count').first();
  const labelProducts = $countSpan.attr('data-label') || 'products';

  if (!actueleCount && $countSpan.length) {
    actueleCount = parseInt($countSpan.text().replace(/[^0-9]/g, '')) || 0;
  }

  if ($countSpan.length) {
    $countSpan.html('(' + actueleCount + '<span class="mobile-hide-text"> ' + labelProducts + '</span>)');
  }

  const $mobileApplyBtn = $('#apply-woof-filter');

  if ($mobileApplyBtn.length) {
    const isSingle = parseInt(actueleCount) === 1;
    const translationKey = isSingle ? 'mobileFilterTextTranslationSingle' : 'mobileFilterTextTranslationPlural';

    if (typeof window.translationsFilter !== 'undefined' && window.translationsFilter[translationKey]) {
      let buttonText = window.translationsFilter[translationKey].replace('%s', actueleCount);
      $mobileApplyBtn.html(buttonText + ' <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<mask id="mask0_5587_15493" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">\n' +
        '<rect width="24" height="24" fill="#D9D9D9"/>\n' +
        '</mask>\n' +
        '<g mask="url(#mask0_5587_15493)">\n' +
        '<path d="M12.5998 12.0008L8.6998 8.10078C8.51647 7.91745 8.4248 7.68411 8.4248 7.40078C8.4248 7.11745 8.51647 6.88411 8.6998 6.70078C8.88314 6.51745 9.11647 6.42578 9.3998 6.42578C9.68314 6.42578 9.91647 6.51745 10.0998 6.70078L14.6998 11.3008C14.7998 11.4008 14.8706 11.5091 14.9123 11.6258C14.954 11.7424 14.9748 11.8674 14.9748 12.0008C14.9748 12.1341 14.954 12.2591 14.9123 12.3758C14.8706 12.4924 14.7998 12.6008 14.6998 12.7008L10.0998 17.3008C9.91647 17.4841 9.68314 17.5758 9.3998 17.5758C9.11647 17.5758 8.88314 17.4841 8.6998 17.3008C8.51647 17.1174 8.4248 16.8841 8.4248 16.6008C8.4248 16.3174 8.51647 16.0841 8.6998 15.9008L12.5998 12.0008Z" fill="white"/>\n' +
        '</g>\n' +
        '</svg>\n');
    } else {
      const labelShow = document.documentElement.lang === 'nl' ? 'Toon' : 'Show';
      const labelResult = document.documentElement.lang === 'nl' ? 'resultaat' : 'result';
      const labelResults = document.documentElement.lang === 'nl' ? 'resultaten' : 'results';
      const correctLabel = isSingle ? labelResult : labelResults;

      $mobileApplyBtn.html(`${labelShow} ${actueleCount} ${correctLabel}`);
    }
  }
};

export var initMobileFilterToggle = () => {
  const $body = $('body');

  $(document).on('click', '.btn-inline-filter', function(e) {
    e.preventDefault();
    $('.wolky-productcategories-content').addClass('is-open');
    $body.css('overflow', 'hidden');

    if ($('.mobile-filter-reset-wrapper').length === 0) {
      let resetUrl = $('.woof_reset_search_form').first().attr('data-link') || window.location.pathname;
      $('.mobile-filter-footer').append(`
            <div class="mobile-filter-reset-wrapper">
                <button class="woof_reset_search_form" data-link="${resetUrl}">Reset filters</button>
            </div>
        `);
    }
  });

  $(document).on('click', '.btn-close-filter, .btn-apply-filter', function(e) {
    e.preventDefault();
    $('.wolky-productcategories-content').removeClass('is-open');
    $body.css('overflow', '');
  });

  $(window).on('resize', function() {
    if (window.innerWidth > 1200) {
      const $filterOverlay = $('.wolky-productcategories-content');
      if ($filterOverlay.hasClass('is-open')) {
        $filterOverlay.removeClass('is-open');
        $body.css('overflow', '');
      }
    }
  });
}

export var initWoofFilterAccordions = () => {
  checkActiveFilters();
  $(document).off('click', '.woof_container_inner h4')
    .on('click', '.woof_container_inner h4', function(e) {
      e.preventDefault();
      const $title = $(this);
      const $content = $title.siblings('.woof_block_html_items');
      $content.slideToggle(300);
      $title.toggleClass('is-open');
    });
}

export var checkActiveFilters = () => {
  const isMobile = window.innerWidth <= 1200;

  $('.woof_container_inner').each(function() {
    const $container = $(this);
    const $title = $container.find('h4');
    const $content = $container.find('.woof_block_html_items');
    let selectedValues = [];

    $container.find('input:checked').each(function() {
      let labelText = $(this).siblings('label').text() || $(this).closest('li').find('.woof_color_title').text();
      if (labelText) {
        labelText = labelText.replace(/\(\d+\)/g, '').trim();
        selectedValues.push(labelText);
      }
    });

    $container.find('select option:selected:not([value="0"]):not([value=""])').each(function() {
      selectedValues.push($(this).text().replace(/\(\d+\)/g, '').trim());
    });

    if (selectedValues.length > 0) {
      if (!isMobile && !$title.hasClass('is-open')) {
        $title.addClass('is-open');
        $content.show();
      }
    }

    if (!isMobile) {
      $title.find('.filter-subtitle').remove();
      return;
    }

    let $subtitle = $title.find('.filter-subtitle');
    if (selectedValues.length > 0) {
      if ($subtitle.length === 0) {
        $title.append('<span class="filter-subtitle">' + selectedValues.join(', ') + '</span>');
      } else {
        $subtitle.text(selectedValues.join(', '));
      }
    } else {
      $subtitle.remove();
    }
  });
}

export var initProductArchiveColorHover = () => {
  const body = document.body;
  if (!document.querySelector('.products')) return;

  body.addEventListener('mouseover', function(event) {
    const swatch = event.target.closest('.archive-color-swatch');
    if (!swatch) return;
    const productCard = swatch.closest('li.product');
    const container = productCard?.querySelector('.ws-product-image-hover-container');
    const productImage = container?.querySelector('.primary-img');
    if (!productImage) return;

    if (productImage.hoverTimeout) {
      clearTimeout(productImage.hoverTimeout);
      productImage.hoverTimeout = null;
    }

    let newImageSrc = swatch.dataset.imageSrc;
    if (!newImageSrc) return;

    container.classList.add('has-hovered-swatch');
    if (!productImage.dataset.originalSrc) {
      productImage.dataset.originalSrc = productImage.src;
      productImage.dataset.originalSrcset = productImage.getAttribute('srcset') || '';
    }

    productImage.dataset.currentTargetSrc = newImageSrc;
    if (productImage.getAttribute('src') === newImageSrc) {
      productImage.style.opacity = '1';
      return;
    }

    productImage.style.opacity = '0.3';
    const tempImg = new Image();
    tempImg.src = newImageSrc;
    tempImg.onload = () => {
      if (productImage.dataset.currentTargetSrc === newImageSrc) {
        productImage.src = newImageSrc;
        productImage.removeAttribute('srcset');
        productImage.style.opacity = '1';
      }
    };
  });

  body.addEventListener('mouseout', function(event) {
    const wrapper = event.target.closest('.archive-color-options-wrapper');
    if (!wrapper) return;
    if (event.relatedTarget && event.relatedTarget.closest('.archive-color-options-wrapper') === wrapper) return;

    const productCard = wrapper.closest('li.product');
    const container = productCard?.querySelector('.ws-product-image-hover-container');
    const productImage = container?.querySelector('.primary-img');
    if (!productImage || !productImage.dataset.originalSrc) return;

    productImage.dataset.currentTargetSrc = productImage.dataset.originalSrc;
    if (productImage.hoverTimeout) clearTimeout(productImage.hoverTimeout);

    productImage.hoverTimeout = setTimeout(() => {
      if (productImage.dataset.currentTargetSrc === productImage.dataset.originalSrc) {
        productImage.src = productImage.dataset.originalSrc;
        if (productImage.dataset.originalSrcset) productImage.setAttribute('srcset', productImage.dataset.originalSrcset);
        productImage.style.opacity = '1';
        container?.classList.remove('has-hovered-swatch');
        delete productImage.dataset.originalSrc;
        delete productImage.dataset.originalSrcset;
      }
    }, 50);
  });
}

export var initVideoClickArchive = () => {
  const playIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon></svg>';
  const pauseIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" width="20" height="20"><circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line></svg>';

  $(document).on('click', '.ws-video-badge.play-btn', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const $badge = $(this);
    const $container = $badge.closest('.ws-product-image-hover-container');
    const video = $container.find('video.archive-inline-video')[0];
    if (!video) return;

    if ($container.hasClass('video-is-playing')) {
      video.pause();
      $container.removeClass('video-is-playing');
      $badge.html(playIcon);
    } else {
      $container.addClass('video-is-playing');
      video.play().catch(err => console.log('Video kon niet afspelen:', err));
      $badge.html(pauseIcon);
    }
  });

  $(document).on('mouseleave', '.has-video', function() {
    const $container = $(this).find('.ws-product-image-hover-container');
    const video = $container.find('video.archive-inline-video')[0];
    const $badge = $container.find('.ws-video-badge.play-btn');
    if ($container.hasClass('video-is-playing') && video) {
      video.pause();
      video.currentTime = 0;
      $container.removeClass('video-is-playing');
      $badge.html(playIcon);
    }
  });
}

export var addClassToSinglePrice = () => {
  $('.price:has(> .woocommerce-Price-amount)').addClass('single_price');
}

export var addBackButtonFunctionality = () => {
  $('#back-button').on('click', function (e) {
    e.preventDefault();
    window.history.back();
  });
}

export var styleTopPanelColors = () => {
  $('.woof_products_top_panel_ul a[data-tax="pa_color"]').each(function() {
    const $link = $(this);
    let slug = $link.data('slug');
    if (slug) {
      let $colorInput = $('.woof_list_color input.woof_color_term[name="' + slug + '"]');
      if ($colorInput.length) {
        let bgColor = $colorInput.data('color');
        let bgImg = $colorInput.data('img');
        let inlineStyle = '';
        if (bgImg && bgImg !== 'none') {
          inlineStyle = `background-image: url('${bgImg}'); background-size: cover;`;
        } else if (bgColor) {
          inlineStyle = `background-color: ${bgColor};`;
        }
        if (inlineStyle && $link.find('.ws-color-swatch-top').length === 0) {
          $link.prepend(`<span class="ws-color-swatch-top" style="${inlineStyle}"></span>`);
        }
      }
    }
  });
}

export var styleSidebarColors = () => {
  $('.woof_list_color li').each(function() {
    const $li = $(this);
    const $input = $li.find('input.woof_color_term');
    let bgColor = $input.data('color');
    let bgImg = $input.data('img');
    if (bgImg && bgImg !== 'none' && bgImg !== '') {
      $li.css({
        'background-image': `url('${bgImg}')`,
        'background-size': 'cover',
      });
    } else if (bgColor) {
      $li.css('background-color', bgColor);
    }
  });
}

export var backToTop = () => {
  $(window).resize(function () {
    if ($(window).width() > 1024) {
      $('.mobile-filters').fadeOut();
      $('.backtotop-container').fadeOut();
    } else {
      if ($(this).scrollTop() > 100) {
        $('.mobile-filters').fadeIn();
        $('.backtotop-container').fadeIn();
      }
    }
  });

  $(window).scroll(function () {

    if ($(this).scrollTop() > 100) {
      $('.backtotop-container').fadeIn();
    } else {
      $('.backtotop-container').fadeOut();
    }
  });

  $('.wolky-backtotop').click(function () {
    $('html, body').animate({scrollTop: 0}, 1000);
  });
}
export var initChosenFiltersText = () => {
  const $panel = $('.woof_products_top_panel_ul');

  if ($panel.length && $panel.children('li').length > 0 && $panel.find('.ws-gekozen-filters-tekst').length === 0) {

    let text = '';
    if (typeof translationsFilter !== 'undefined' && translationsFilter.chosenFiltersText) {
      text = translationsFilter.chosenFiltersText;
    }

    $panel.prepend('<li class="ws-gekozen-filters-tekst" style="display: inline-block; color: #000; margin-right: 15px; margin-bottom: 5px; vertical-align: middle;">' + text + '</li>');
  }
}
